import React, { FC } from "react";
import {
    Box,
    Flex,
    Heading,
    Text,
    Icon,
    Image,
} from "@smile2impress/components/relaunch";
import { LogoIcon } from "@smile2impress/components";

import { ReferralHeroProps } from "./ReferralHero.types";

export const ReferralHero: FC<ReferralHeroProps> = ({
    content: { title, subtitle, description, card },
}) => {
    return (
        <Flex
            direction="column"
            position="relative"
            width="100%"
            maxW="800px"
            alignItems={["flex-start", "flex-start", "center"]}
            mx="auto"
            justifyContent="center"
        >
            {card && (
                <Flex
                    w={["330px", "330px", "541px"]}
                    bg={card.bgColor || "base.bitterSweet"}
                    borderRadius="sm"
                    transform="rotate(2deg)"
                    p={[2, 2, 3]}
                    mb={[2.5, 3, 3]}
                    alignItems="center"
                >
                    <Flex
                        w={["100px", "100px", "160px"]}
                        h={["100px", "100px", "160px"]}
                        aspectRatio="1/1"
                        bg="base.white"
                        borderRadius="sm"
                        alignItems="center"
                        justifyContent="center"
                    >
                        {card.imageUrl ? (
                            <Image
                                src={card.imageUrl}
                                alt={card.title}
                                w="80%"
                                h="auto"
                            />
                        ) : (
                            <Icon
                                h="auto"
                                w="80%"
                                as={LogoIcon}
                                color="base.logo"
                            />
                        )}
                    </Flex>
                    <Box ml={[1, 1, 2]}>
                        <Text textStyle="special3" color="base.white" mb={1}>
                            {card.title}
                        </Text>
                        {card.text && (
                            <Text
                                textStyle="special"
                                fontSize={[36, 36, 56]}
                                color={card.textColor || "base.white"}
                            >
                                {card.text}
                            </Text>
                        )}
                    </Box>
                </Flex>
            )}

            <Heading
                as="h1"
                textStyle={["H2", "H2", "H1"]}
                mb={2}
                mt={0}
                textAlign={["left", "left", "center"]}
                color="base.bitterSweet"
                w="100%"
            >
                {title}
            </Heading>
            {subtitle && (
                <Text
                    textStyle="title3"
                    maxWidth={["100%", "100%", "800px"]}
                    w="100%"
                    textAlign={["left", "left", "center"]}
                >
                    {subtitle}
                </Text>
            )}
            {description && (
                <Text
                    textStyle="body"
                    maxWidth={["100%", "100%", "800px"]}
                    w="100%"
                    textAlign={["left", "left", "center"]}
                >
                    {description}
                </Text>
            )}
        </Flex>
    );
};
